<template>
  <div class="card-help finger-style" @click="goIconUrl(wordChain.url)">
    <div class="help-title ellipsis">
      {{ wordChain && wordChain.text }}
    </div>
    <i class="icon-outline_entrance"></i>
  </div>
</template>

<script>
export default {
  name: 'HelpCard',
  props: {
    wordChain: Object,
    orderId: String,
  },
  methods: {
    goIconUrl(url) {
      this.$emit('goIconUrl', {
        type: 'helpCard',
        url,
      });
    },
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
